export default __webpack_public_path__ + "static/media/ic-RightFilled.acf8ab8d.svg";